import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const children: NodeRenderer = (node, children) => <>{children}</>
